import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AppWithLocale from './components/AppWithLocale';
import LanguageDetection from './components/LanguageDetection';
import SEO from './components/SEO';
import { getUserPreferredLocale } from './locales';

function App() {
  const [showLanguageDetection, setShowLanguageDetection] = useState(false);

  useEffect(() => {
    // 检查是否已经显示过语言检测
    const hasShown = localStorage.getItem('hasShownLanguageDetection');
    if (!hasShown) {
      const userLocale = getUserPreferredLocale();
      if (userLocale !== 'en') {
        setShowLanguageDetection(true);
      }
    }
  }, []);

  const handleCloseLanguageDetection = () => {
    setShowLanguageDetection(false);
    localStorage.setItem('hasShownLanguageDetection', 'true');
  };

  return (
    <Router>
      <div className="App">
        {/* 语言检测弹窗 */}
        {showLanguageDetection && (
          <LanguageDetection onClose={handleCloseLanguageDetection} />
        )}

        {/* 路由配置 */}
        <Routes>
          {/* 默认路由重定向到英语 */}
          <Route path="/" element={<Navigate to="/en" replace />} />
          
          {/* 英语页面 */}
          <Route path="/en" element={
            <>
              <SEO locale="en" />
              <AppWithLocale locale="en" />
            </>
          } />
          
          {/* 中文页面 */}
          <Route path="/zh" element={
            <>
              <SEO locale="zh" />
              <AppWithLocale locale="zh" />
            </>
          } />
          
          {/* 荷兰语页面 */}
          <Route path="/nl" element={
            <>
              <SEO locale="nl" />
              <AppWithLocale locale="nl" />
            </>
          } />
          
          {/* 404重定向到英语 */}
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;